import { Config } from '../services/Config';

export const AppLauncherURLs: Record<string, string> = {
  RECKON: Config.APPLICATION_RECKON_APP_LAUNCHER_URL,
  DEADLYDIGITS: Config.APPLICATION_DEADLY_DIGITS_APP_LAUNCHER_URL,
  ALL: Config.APPLICATION_RECKON_APP_LAUNCHER_URL,
};
